import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { selectors } from "reducers";
import { Tabs, Tab, TabList, TabPanel } from "react-tabs";
import OutrachDates from "./scheduled_dates";
import ComplianceDate from "./complianc-date";
import ResupplyDate from "./resupply-date";

const PatientOutreachDates = ({ patientInfo, patientId, readOnly }) => {
  return (
    <div>
      {patientInfo?.patientTypeData?.compliance_patient ? (
        <ComplianceDate
          patientInfo={patientInfo}
          patientId={patientId}
          readOnly={readOnly}
        />
      ) : (
        <ResupplyDate
          patientInfo={patientInfo}
          patientId={patientId}
          readOnly={readOnly}
        />
      )}
      <div className="patient-schedule-dates-container">
        <Tabs direction={"rtl"}>
          {patientInfo.patient_product_lines?.length >= 1 && (
            <TabList style={{ display: "flex", flexDirection: "row", flex: 1 }}>
              <h3
                style={{
                  display: "flex",
                  flex: 1,
                  flexDirection: "row",
                  fontSize: "1.4em",
                  textTransform: "uppercase"
                }}
              >
                Product Lines
              </h3>
              {patientInfo.patient_product_lines?.map(x => (
                <Tab key={`outreach-tab_${x.text}_${patientId}`}>{x.text}</Tab>
              ))}
            </TabList>
          )}
          {patientInfo.patient_product_lines?.map(x => (
            <TabPanel key={`outreach-panel_${x.text}_${patientId}`}>
              <OutrachDates
                patientId={patientId}
                product_line={x.text}
                outreach_date={x.outreach_date}
                outreach_cycle={x.outreach_cycle}
                override_outreach_date={x.override_outreach_date}
                patientInfo={patientInfo}
                readOnly={readOnly}
              />
            </TabPanel>
          ))}
        </Tabs>
      </div>
    </div>
  );
};

PatientOutreachDates.propTypes = {
  patientId: PropTypes.string.isRequired,
  patientInfo: PropTypes.object.isRequired,
  readOnly: PropTypes.bool.isRequired
};

PatientOutreachDates.defaultProps = {
  readOnly: false
};

export default connect((state, { patientId }) => ({
  patientInfo: selectors.getPatientInfo(state, patientId)
}))(PatientOutreachDates);
